export default function useDataConfiguration(props) {
  return {
    variables: {
      id: props.task_id,
    },
    pause: !props.task_id,
  }
}
